import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-points-help-dialog',
  templateUrl: './points-help-dialog.component.html',
  styleUrls: ['./points-help-dialog.component.scss']
})
export class PointsHelpDialogComponent {
  constructor(public dialogRef: MatDialogRef<PointsHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
